// import { Http } from '../../../applications/Http.js'
import { Http } from '../../../applications/Http.js'
import Service from '../../../applications/Service.js'

class PeasantService extends Service {
    static messages = {
        update_success: 'Modification Paysans avec succès.',
        update_error: 'Erreur de modification.',
        delete_success: 'Suppression effectuée.',
        delete_error: 'Erreur de suppression.',
        create_success: 'Création Paysans avec succès.',
        create_error: 'Erreur de création.'
    }
    static load() {
        this.setUrl('/api/peasants')
        return this
    }

    static async getById(id) {
        return await Http.get([this.url, id].join('/'), {})
    }
    static async getByCode(code) {
        return await Http.get([this.url, 'byCode', code].join('/'), {})
    }

    static async getAllPeasant() {
        try {
            const response = await Http.get('/api/peasants')
            console.log('response user', response.data)
            return response.data
        } catch (error) {
            console.error("Une erreur s'est produite lors de la récupération des utilisateurs :", error)
            throw error
        }
    }
}

export default PeasantService
